module.exports = __webpack_public_path__ + "static/media/forklift.058a211c.svg";